<script>
  import ActionBar from "$lib/components/ActionBar.svelte";
  import { textToId } from "$lib/utilities/dom-helpers";
  import { CTA_TYPE_MAP } from "$lib/utilities/constants";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let data;

  const location = data.fields?.venue?.fields;
  const text = location ? undefined : data.fields?.text;

  const actions =
    data.fields?.actionItems?.map((action) => {
      const { title, description, cta } = action.fields;

      return {
        title,
        description,
        cta: cta
          ? {
              url: cta?.fields?.destination?.fields?.url,
              type: cta?.fields?.type ? CTA_TYPE_MAP[cta?.fields?.type] : "textLink",
              text: cta?.fields?.text,
              id: title ? `actionbar-cta-${textToId(title)}` : null
            }
          : null
      };
    }) || [];

  const showActionItemDetailsOnMobile = data.fields?.showActionItemDetailsOnMobile;
</script>

<ActionBar class={className} {text} {actions} {location} {showActionItemDetailsOnMobile} />
